import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { trackLinkClick } from '../../../common/metrics.js';
import img from '../../../../assets/images/arrow-right.svg.js';
import img$1 from '../../../../assets/images/logo-footer.svg.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { isEqual, triggerExternalLinkPopup, setNavButtonHover, unsetNavButtonHover } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { normalizeUnicodeText } from '../../../common/navigation-titles.js';
import { renderLeafPromo } from './helpers.js';
import css_248z from './sub-nav.scss.js';

class SubNav extends s {
    constructor() {
        super(...arguments);
        this.activeLeaf = null;
        this.menuLogo = '';
        this.LogoAltText = '';
        this.forwardText = '';
        this.rtl = false;
        this.submenuIsOpen = false;
        this.submenuIsClosing = false;
        this.activeImage = null;
        this.activeImageFading = false;
        this.externalLinkPopup = null;
        this.showLogo = true;
        this.stealFocus = () => {
            setTimeout(() => {
                var _a, _b;
                (_b = (_a = this.renderRoot.querySelector('.submenu')) === null || _a === void 0 ? void 0 : _a.querySelector('a')) === null || _b === void 0 ? void 0 : _b.focus();
            }, 0);
        };
        this.focusCloseButton = () => {
            var _a, _b, _c, _d, _e;
            (_e = (_d = (_c = (_b = (_a = document
                .querySelector('main-nav')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.close-button')) === null || _c === void 0 ? void 0 : _c.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('button')) === null || _e === void 0 ? void 0 : _e.focus();
        };
    }
    setActiveImage(imgSrc = null) {
        if (imgSrc === this.activeImage)
            return;
        this.activeImageFading = true;
        setTimeout(() => {
            this.activeImage = imgSrc;
            this.activeImageFading = false;
            this.showLogo = !imgSrc;
        }, 300);
    }
    setActiveLeaf(leaf) {
        if (leaf.items.length === 0) {
            document.location.href = leaf.link;
            return;
        }
        this.submenuIsClosing = true;
        setTimeout(() => {
            if (isEqual(this.activeLeaf, leaf)) {
                this.activeLeaf = null;
            }
            else {
                this.activeLeaf = leaf;
            }
            this.submenuIsClosing = false;
            this.stealFocus();
        }, 300);
    }
    onLinkClick(e) {
        trackLinkClick(e);
        triggerExternalLinkPopup(e, this);
    }
    renderBranch() {
        return this.data.items.map(leaf => {
            var _a;
            if (((_a = leaf.items) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return $ `<li><a href="${l(leaf.link)}" class="leaf ${o({
                    active: isEqual(leaf, this.activeLeaf),
                })}" @mouseover="${() => this.setActiveImage(leaf.img || null)}" @click="${this.onLinkClick}"><div class="content"><p class="title">${normalizeUnicodeText(leaf.title)}</p><p class="description">${leaf.description}</p><icon-button customTabIndex="-1" styleType="${ButtonStyleTypes.OUTLINED_DARK}" aria-label="${normalizeUnicodeText(leaf.title)}" @mouseover="${setNavButtonHover}" @mouseleave="${unsetNavButtonHover}"><img slot="icon" .src="${img}" alt=""></icon-button></div></a></li>`;
            }
            return $ `<li><a class="leaf ${o({ active: isEqual(leaf, this.activeLeaf) })}" role="button" href="${l(leaf.link)}" @click="${(e) => {
                e.preventDefault();
                this.setActiveLeaf(leaf);
            }}" @mouseover="${() => this.setActiveImage(leaf.img || null)}"><p class="title">${normalizeUnicodeText(leaf.title)}</p><p class="description">${leaf.description}</p><icon-button customTabIndex="-1" styleType="${ButtonStyleTypes.OUTLINED_DARK}" aria-label="${normalizeUnicodeText(leaf.title)}" @mouseover="${setNavButtonHover}" @mouseleave="${unsetNavButtonHover}"><img slot="icon" .src="${img}" alt=""></icon-button></a></li>`;
        });
    }
    renderLeafLinks() {
        var _a, _b;
        return ((_b = (_a = this.activeLeaf) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length)
            ? this.activeLeaf.items.map(item => $ `<a @click="${this.onLinkClick}" href="${item.link}">${normalizeUnicodeText(item.title)}</a>`)
            : null;
    }
    renderLeaf() {
        return this.activeLeaf
            ? $ `<div class="submenu-inner"><ul class="submenu-links"><li><a class="primary-link" href="${l(this.activeLeaf.link)}" @click="${this.onLinkClick}">${normalizeUnicodeText(this.activeLeaf.title)}</a></li>${this.renderLeafLinks()}</ul>${renderLeafPromo(this.activeLeaf.promo)} <input type="text" aria-hidden="true" aria-disabled="true" style="opacity:0" @focus="${() => this.focusCloseButton()}"></div>`
            : null;
    }
    renderLogo() {
        return !this.data.img && this.showLogo
            ? $ `<img loading="lazy" class="logo" src="${this.menuLogo || img$1}" alt="${this.LogoAltText || 'Convatec Logo'}" aria-hidden="true">`
            : null;
    }
    firstUpdated() {
        const modal = document.querySelector('cvt-modal[popupid="external-link"]');
        if (!modal)
            return;
        this.externalLinkPopup = modal.querySelector('external-link');
    }
    render() {
        const submenuClassMap = {
            submenu: true,
            rtl: this.rtl || isRTL(),
            open: !!this.activeLeaf,
            closing: this.submenuIsClosing,
        };
        return $ `<div class="modal-menu ${o({ rtl: this.rtl || isRTL() })}"><div class="left" @click="${(e) => e.stopPropagation()}"><div class="background ${o({ fading: this.activeImageFading })}" style="background-image:url('${l(this.activeImage)}')"></div>${this.renderLogo()}</div><div class="right ${o({ darkened: !!this.activeLeaf })}" @click="${(e) => e.stopPropagation()}"><ul class="holder"><a class="root-page-link" href="${this.data.link}" @click="${this.onLinkClick}">${normalizeUnicodeText(this.data.headlineTitle)}</a> ${this.renderBranch()}</ul></div><div class="${o(submenuClassMap)}" @click="${(e) => e.stopPropagation()}">${this.renderLeaf()}</div></div>`;
    }
}
SubNav.styles = css_248z;
__decorate([
    e({ type: Object })
], SubNav.prototype, "data", void 0);
__decorate([
    e()
], SubNav.prototype, "activeLeaf", void 0);
__decorate([
    e()
], SubNav.prototype, "menuLogo", void 0);
__decorate([
    e()
], SubNav.prototype, "LogoAltText", void 0);
__decorate([
    e()
], SubNav.prototype, "forwardText", void 0);
__decorate([
    e({ type: Boolean })
], SubNav.prototype, "rtl", void 0);
__decorate([
    t()
], SubNav.prototype, "submenuIsOpen", void 0);
__decorate([
    t()
], SubNav.prototype, "submenuIsClosing", void 0);
__decorate([
    t()
], SubNav.prototype, "activeImage", void 0);
__decorate([
    t()
], SubNav.prototype, "activeImageFading", void 0);
__decorate([
    t()
], SubNav.prototype, "externalLinkPopup", void 0);
__decorate([
    t()
], SubNav.prototype, "showLogo", void 0);
customElements.define('sub-nav', SubNav);

export { SubNav };
